<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-navicon'"></i>
        </button>
      </div>
      <a class="navbar-brand">{{ this.$route.name }}</a>
      <button type="button" class="navbar-toggler navbar-toggler-right" :class="{ toggled: $sidebar.showSidebar }"
        aria-expanded="false" @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-end" style="margin-right: 10px;">
        <ul class="nav navbar-nav mr-right">
          <div v-if="this.$route.meta.note">
          <accident-status-modal></accident-status-modal>
          
          </div>
        </ul>
        <ul class="nav navbar-nav mr-right">
          <div v-if="this.$route.meta.stage" style="margin-right: 20px;">
            <alert-modal></alert-modal>
          </div>
        </ul>

      </div>
    </div>
  </nav>
</template>

<script>
import AlertModal from "../views/components/AlertModal.vue";
import AccidentStatusModal from "../views/components/AccidentStatusModal.vue";
export default {
  components: {
    AlertModal,
    AccidentStatusModal
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
      search: "",
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    handleTimelineClick() {
    },
  },
};
</script>
